import React from 'react';

const EntityContext = React.createContext(null);
export default EntityContext;

export const AggregateRootContext = React.createContext(null);